import React from 'react';
import { Box, Skeleton, Grid } from '@mui/material';

const PageSkeletonProfile = () => {
  return (
    <Box sx={{ width: '100%', marginTop: '20px' }}>
      {/* Personal Information Section */}
      <Grid xs={12} sm={12} md={12} lg={12} sx={{
        margin: '0px auto 40px auto',
        paddingTop: '20px',
        border: '1px solid #E4EBF6',
        borderRadius: '8px',
        padding: '24px',
        bgcolor: 'white',
        width: '100%'
      }}>
        <Box sx={{ textAlign: 'left' }}>
          <Skeleton variant="text" width="20%" height={24} sx={{ mb: 1, bgcolor: '#E6EDF9' }} />
          <Skeleton variant="text" width="40%" height={20} sx={{ mb: 3, bgcolor: '#E6EDF9' }} />

          {/* Profile Image */}
          <Skeleton variant="circular" width={100} height={100} sx={{ mb: 5, bgcolor: '#E6EDF9' }} />

          {/* Form Fields */}
          {[...Array(4)].map((_, i) => (
            <Box key={i} sx={{ mb: 3 }}>
              <Skeleton variant="text" width="15%" height={20} sx={{ mb: 1, bgcolor: '#E6EDF9' }} />
              <Skeleton variant="rectangular" height={48} sx={{ bgcolor: '#E6EDF9', borderRadius: '5px' }} />
            </Box>
          ))}
        </Box>
      </Grid>

      {/* Email Settings Section */}
      {/* <Grid xs={12} sm={12} md={12} lg={12} sx={{
        margin: '20px auto 40px auto',
        border: '1px solid #E4EBF6',
        borderRadius: '8px',
        padding: '24px',
        bgcolor: 'white'
      }}>
        <Box sx={{ textAlign: 'left' }}>
          <Skeleton variant="text" width="20%" height={24} sx={{ mb: 1, bgcolor: '#E6EDF9' }} />
          <Skeleton variant="text" width="40%" height={20} sx={{ mb: 3, bgcolor: '#E6EDF9' }} />
          <Skeleton variant="rectangular" height={80} sx={{ bgcolor: '#E6EDF9', borderRadius: '5px' }} />
        </Box>
      </Grid> */}

      {/* Password Section */}
      {/* <Grid xs={12} sm={12} md={12} lg={12} sx={{
        margin: '20px auto 40px auto',
        border: '1px solid #E4EBF6',
        borderRadius: '8px',
        padding: '24px',
        bgcolor: 'white'
      }}>
        <Box sx={{ textAlign: 'left' }}>
          <Skeleton variant="text" width="20%" height={24} sx={{ mb: 1, bgcolor: '#E6EDF9' }} />
          <Skeleton variant="text" width="40%" height={20} sx={{ mb: 3, bgcolor: '#E6EDF9' }} />
          <Skeleton variant="rectangular" width={150} height={40} sx={{ bgcolor: '#E6EDF9', borderRadius: '8px' }} />
        </Box>
      </Grid> */}

      {/* Delete Account Section */}
      {/* <Grid xs={12} sm={12} md={12} lg={12} sx={{
        margin: '20px auto 20px auto',
        border: '1px solid #E4EBF6',
        borderRadius: '8px',
        padding: '24px',
        bgcolor: 'white'
      }}>
        <Box sx={{ textAlign: 'left' }}>
          <Skeleton variant="text" width="20%" height={24} sx={{ mb: 1, bgcolor: '#E6EDF9' }} />
          <Skeleton variant="text" width="40%" height={20} sx={{ mb: 3, bgcolor: '#E6EDF9' }} />
          <Skeleton variant="rectangular" width={150} height={40} sx={{ bgcolor: '#E6EDF9', borderRadius: '8px' }} />
        </Box>
      </Grid> */}
    </Box>
  );
};

export default PageSkeletonProfile;
